import { SVGProps } from "react";

function SvgComponent(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="488"
      height="242"
      viewBox="0 0 488 242"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M41.5 29V226.5" stroke="#D2D3D5" />
      <g filter="url(#filter0_dd)">
        <path
          d="M476 4H12C9.79086 4 8 5.79086 8 8V66C8 68.2091 9.79086 70 12 70H476C478.209 70 480 68.2091 480 66V8C480 5.79086 478.209 4 476 4Z"
          fill="black"
        />
      </g>
      <path
        d="M476 4H12C9.79086 4 8 5.79086 8 8V66C8 68.2091 9.79086 70 12 70H476C478.209 70 480 68.2091 480 66V8C480 5.79086 478.209 4 476 4Z"
        fill="white"
      />
      <path
        d="M149.761 22.1484H73.9861C72.8815 22.1484 71.9861 23.0439 71.9861 24.1484V29.2234C71.9861 30.328 72.8815 31.2234 73.9861 31.2234H149.761C150.866 31.2234 151.761 30.328 151.761 29.2234V24.1484C151.761 23.0439 150.866 22.1484 149.761 22.1484Z"
        fill="#F1F1F1"
      />
      <path
        d="M461.381 22.1484H385.606C384.501 22.1484 383.606 23.0439 383.606 24.1484V29.2234C383.606 30.328 384.501 31.2234 385.606 31.2234H461.381C462.486 31.2234 463.381 30.328 463.381 29.2234V24.1484C463.381 23.0439 462.486 22.1484 461.381 22.1484Z"
        fill="#F1F1F1"
      />
      <path
        d="M322.606 41.125H73.9861C72.8815 41.125 71.9861 42.0204 71.9861 43.125V48.2C71.9861 49.3046 72.8815 50.2 73.9861 50.2H322.606C323.711 50.2 324.606 49.3046 324.606 48.2V43.125C324.606 42.0204 323.711 41.125 322.606 41.125Z"
        fill="#F1F1F1"
      />
      <path
        d="M322.606 41.125H73.9861C72.8815 41.125 71.9861 42.0204 71.9861 43.125V48.2C71.9861 49.3046 72.8815 50.2 73.9861 50.2H322.606C323.711 50.2 324.606 49.3046 324.606 48.2V43.125C324.606 42.0204 323.711 41.125 322.606 41.125Z"
        fill="#F1F1F1"
      />
      <g opacity="0.147">
        <path
          opacity="0.147"
          d="M41.2401 53.5C50.4191 53.5 57.8601 46.1127 57.8601 37C57.8601 27.8873 50.4191 20.5 41.2401 20.5C32.0611 20.5 24.6201 27.8873 24.6201 37C24.6201 46.1127 32.0611 53.5 41.2401 53.5Z"
          fill="url(#paint0_linear)"
        />
      </g>
      <g filter="url(#filter1_dd)">
        <path
          d="M476 84H12C9.79086 84 8 85.7909 8 88V146C8 148.209 9.79086 150 12 150H476C478.209 150 480 148.209 480 146V88C480 85.7909 478.209 84 476 84Z"
          fill="black"
        />
      </g>
      <path
        d="M476 84H12C9.79086 84 8 85.7909 8 88V146C8 148.209 9.79086 150 12 150H476C478.209 150 480 148.209 480 146V88C480 85.7909 478.209 84 476 84Z"
        fill="white"
      />
      <path
        d="M149.761 102.148H73.9861C72.8815 102.148 71.9861 103.044 71.9861 104.148V109.223C71.9861 110.328 72.8815 111.223 73.9861 111.223H149.761C150.866 111.223 151.761 110.328 151.761 109.223V104.148C151.761 103.044 150.866 102.148 149.761 102.148Z"
        fill="#F1F1F1"
      />
      <path
        d="M461.381 102.148H385.606C384.501 102.148 383.606 103.044 383.606 104.148V109.223C383.606 110.328 384.501 111.223 385.606 111.223H461.381C462.486 111.223 463.381 110.328 463.381 109.223V104.148C463.381 103.044 462.486 102.148 461.381 102.148Z"
        fill="#F1F1F1"
      />
      <path
        d="M322.606 121.125H73.9861C72.8815 121.125 71.9861 122.02 71.9861 123.125V128.2C71.9861 129.305 72.8815 130.2 73.9861 130.2H322.606C323.711 130.2 324.606 129.305 324.606 128.2V123.125C324.606 122.02 323.711 121.125 322.606 121.125Z"
        fill="#F1F1F1"
      />
      <path
        d="M322.606 121.125H73.9861C72.8815 121.125 71.9861 122.02 71.9861 123.125V128.2C71.9861 129.305 72.8815 130.2 73.9861 130.2H322.606C323.711 130.2 324.606 129.305 324.606 128.2V123.125C324.606 122.02 323.711 121.125 322.606 121.125Z"
        fill="#F1F1F1"
      />
      <g opacity="0.211">
        <path
          opacity="0.211"
          d="M41.2401 133.5C50.4191 133.5 57.8601 126.113 57.8601 117C57.8601 107.887 50.4191 100.5 41.2401 100.5C32.0611 100.5 24.6201 107.887 24.6201 117C24.6201 126.113 32.0611 133.5 41.2401 133.5Z"
          fill="url(#paint1_linear)"
        />
      </g>
      <g filter="url(#filter2_dd)">
        <path
          d="M476 164H12C9.79086 164 8 165.791 8 168V226C8 228.209 9.79086 230 12 230H476C478.209 230 480 228.209 480 226V168C480 165.791 478.209 164 476 164Z"
          fill="black"
        />
      </g>
      <path
        d="M476 164H12C9.79086 164 8 165.791 8 168V226C8 228.209 9.79086 230 12 230H476C478.209 230 480 228.209 480 226V168C480 165.791 478.209 164 476 164Z"
        fill="white"
      />
      <path
        d="M149.761 182.148H73.9861C72.8815 182.148 71.9861 183.044 71.9861 184.148V189.223C71.9861 190.328 72.8815 191.223 73.9861 191.223H149.761C150.866 191.223 151.761 190.328 151.761 189.223V184.148C151.761 183.044 150.866 182.148 149.761 182.148Z"
        fill="#F1F1F1"
      />
      <path
        d="M461.381 182.148H385.606C384.501 182.148 383.606 183.044 383.606 184.148V189.223C383.606 190.328 384.501 191.223 385.606 191.223H461.381C462.486 191.223 463.381 190.328 463.381 189.223V184.148C463.381 183.044 462.486 182.148 461.381 182.148Z"
        fill="#F1F1F1"
      />
      <path
        d="M322.606 201.125H73.9861C72.8815 201.125 71.9861 202.02 71.9861 203.125V208.2C71.9861 209.305 72.8815 210.2 73.9861 210.2H322.606C323.711 210.2 324.606 209.305 324.606 208.2V203.125C324.606 202.02 323.711 201.125 322.606 201.125Z"
        fill="#F1F1F1"
      />
      <path
        d="M322.606 201.125H73.9861C72.8815 201.125 71.9861 202.02 71.9861 203.125V208.2C71.9861 209.305 72.8815 210.2 73.9861 210.2H322.606C323.711 210.2 324.606 209.305 324.606 208.2V203.125C324.606 202.02 323.711 201.125 322.606 201.125Z"
        fill="#F1F1F1"
      />
      <g opacity="0.288">
        <path
          opacity="0.288"
          d="M41.2401 213.5C50.4191 213.5 57.8601 206.113 57.8601 197C57.8601 187.887 50.4191 180.5 41.2401 180.5C32.0611 180.5 24.6201 187.887 24.6201 197C24.6201 206.113 32.0611 213.5 41.2401 213.5Z"
          fill="url(#paint2_linear)"
        />
      </g>
      <defs>
        <filter
          id="filter0_dd"
          x="0"
          y="0"
          width="488"
          height="82"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="4" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.12549 0 0 0 0 0.145098 0 0 0 0 0.168627 0 0 0 0.12 0"
          />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="0.5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.12549 0 0 0 0 0.145098 0 0 0 0 0.168627 0 0 0 0.1 0"
          />
          <feBlend mode="normal" in2="effect1_dropShadow" result="effect2_dropShadow" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow" result="shape" />
        </filter>
        <filter
          id="filter1_dd"
          x="0"
          y="80"
          width="488"
          height="82"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="4" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.12549 0 0 0 0 0.145098 0 0 0 0 0.168627 0 0 0 0.12 0"
          />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="0.5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.12549 0 0 0 0 0.145098 0 0 0 0 0.168627 0 0 0 0.1 0"
          />
          <feBlend mode="normal" in2="effect1_dropShadow" result="effect2_dropShadow" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow" result="shape" />
        </filter>
        <filter
          id="filter2_dd"
          x="0"
          y="160"
          width="488"
          height="82"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="4" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.12549 0 0 0 0 0.145098 0 0 0 0 0.168627 0 0 0 0.12 0"
          />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="0.5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.12549 0 0 0 0 0.145098 0 0 0 0 0.168627 0 0 0 0.1 0"
          />
          <feBlend mode="normal" in2="effect1_dropShadow" result="effect2_dropShadow" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow" result="shape" />
        </filter>
        <linearGradient
          id="paint0_linear"
          x1="41.2401"
          y1="81.9166"
          x2="41.2401"
          y2="-18.6967"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#27E9DE" />
          <stop offset="0.52" stop-color="#03A4EC" />
          <stop offset="1" stop-color="#2547A8" />
        </linearGradient>
        <linearGradient
          id="paint1_linear"
          x1="41.2401"
          y1="161.917"
          x2="41.2401"
          y2="61.3033"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#27E9DE" />
          <stop offset="0.52" stop-color="#03A4EC" />
          <stop offset="1" stop-color="#2547A8" />
        </linearGradient>
        <linearGradient
          id="paint2_linear"
          x1="41.2401"
          y1="241.917"
          x2="41.2401"
          y2="141.303"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#27E9DE" />
          <stop offset="0.52" stop-color="#03A4EC" />
          <stop offset="1" stop-color="#2547A8" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default SvgComponent;
